import * as i1$1 from '@angular/router';
import { Router, RouterModule } from '@angular/router';
import * as i0 from '@angular/core';
import { inject, PLATFORM_ID, Injectable, ViewChild, Component, Input, EventEmitter, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { isPlatformBrowser, NgClass } from '@angular/common';
const _forTrack0 = ($index, $item) => $item.title;
function HeaderTopComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const nav_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", nav_r1.isActive);
    i0.ɵɵproperty("href", nav_r1.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", nav_r1.title, " ");
  }
}
function HeaderTopComponent_For_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const nav_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", nav_r2.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", nav_r2.title, " ");
  }
}
function HeaderTopComponent_For_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function HeaderTopComponent_For_12_Template_button_click_0_listener() {
      const lang_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.changeLangHandler(lang_r4.title));
    });
    i0.ɵɵelement(1, "img", 8);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const lang_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", lang_r4.imgSrc, i0.ɵɵsanitizeUrl)("alt", lang_r4.alt);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", lang_r4.isActive);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", lang_r4.title, " ");
  }
}
function HeaderMobileBottomComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function HeaderMobileBottomComponent_For_3_Template_button_click_0_listener() {
      const lang_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeLangHandler(lang_r2.title));
    });
    i0.ɵɵelement(1, "img", 5);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const lang_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", lang_r2.imgSrc, i0.ɵɵsanitizeUrl)("alt", lang_r2.alt);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", lang_r2.isActive);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", lang_r2.title, " ");
  }
}
const _forTrack1 = ($index, $item) => $item.alt;
function HeaderNavFormComponent_Conditional_6_For_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 12);
    i0.ɵɵlistener("click", function HeaderNavFormComponent_Conditional_6_For_7_Template_a_click_1_listener() {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.searchHandler(item_r2.title));
    });
    i0.ɵɵelement(2, "img", 13);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", item_r2.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r2.title);
  }
}
function HeaderNavFormComponent_Conditional_6_ForEmpty_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 8)(1, "span");
    i0.ɵɵtext(2, "Last search is empty.");
    i0.ɵɵelementEnd()();
  }
}
function HeaderNavFormComponent_Conditional_6_For_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const key_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", key_r4.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(key_r4.title);
  }
}
function HeaderNavFormComponent_Conditional_6_For_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 14);
    i0.ɵɵelement(2, "img", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", item_r5.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", item_r5.imageSrc, i0.ɵɵsanitizeUrl)("alt", item_r5.alt);
  }
}
function HeaderNavFormComponent_Conditional_6_For_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 14);
    i0.ɵɵelement(2, "img", 15);
    i0.ɵɵelementStart(3, "h4");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", item_r6.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", item_r6.imageSrc, i0.ɵɵsanitizeUrl)("alt", item_r6.alt);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r6.alt);
  }
}
function HeaderNavFormComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "div", 7)(3, "h3");
    i0.ɵɵtext(4, "Last Search");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul");
    i0.ɵɵrepeaterCreate(6, HeaderNavFormComponent_Conditional_6_For_7_Template, 5, 2, "li", null, i0.ɵɵrepeaterTrackByIndex, false, HeaderNavFormComponent_Conditional_6_ForEmpty_8_Template, 3, 0, "li", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 9)(10, "h3");
    i0.ɵɵtext(11, "Popular Keywords");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "ul");
    i0.ɵɵrepeaterCreate(13, HeaderNavFormComponent_Conditional_6_For_14_Template, 3, 2, "li", null, _forTrack0);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 10)(16, "h3");
    i0.ɵɵtext(17, "Product Recommendation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "ul");
    i0.ɵɵrepeaterCreate(19, HeaderNavFormComponent_Conditional_6_For_20_Template, 3, 3, "li", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 11)(22, "h3");
    i0.ɵɵtext(23, "Category");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "ul");
    i0.ɵɵrepeaterCreate(25, HeaderNavFormComponent_Conditional_6_For_26_Template, 5, 4, "li", null, _forTrack1);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵrepeater(ctx_r2.lastSearch);
    i0.ɵɵadvance(7);
    i0.ɵɵrepeater(ctx_r2.dropdownMenu.popularKeywords);
    i0.ɵɵadvance(6);
    i0.ɵɵrepeater(ctx_r2.dropdownMenu.productRecommendation);
    i0.ɵɵadvance(6);
    i0.ɵɵrepeater(ctx_r2.dropdownMenu.categories);
  }
}
const _c0 = ["*"];
const _c1 = a0 => ["header__base", a0];
function HeaderMobileNavFormComponent_For_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 16);
    i0.ɵɵelement(2, "img", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", item_r1.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r1.title, "");
  }
}
function HeaderMobileNavFormComponent_ForEmpty_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 12);
    i0.ɵɵtext(1, "No Last Search");
    i0.ɵɵelementEnd();
  }
}
function HeaderMobileNavFormComponent_For_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const key_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", key_r2.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(key_r2.title);
  }
}
function HeaderMobileNavFormComponent_For_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 16);
    i0.ɵɵelement(2, "img", 18);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", item_r3.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", item_r3.imageSrc, i0.ɵɵsanitizeUrl)("alt", item_r3.alt);
  }
}
function HeaderMobileNavFormComponent_For_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 16);
    i0.ɵɵelement(2, "img", 18);
    i0.ɵɵelementStart(3, "h4");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", item_r4.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", item_r4.imageSrc, i0.ɵɵsanitizeUrl)("alt", item_r4.alt);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4.alt);
  }
}
function HeaderNavItemComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const child_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", child_r1.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(child_r1.title);
  }
}
function HeaderMobileNavItemComponent_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const child_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", child_r1.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(child_r1.title);
  }
}
function HeaderMainComponent_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "shared-header-nav-item", 11);
    i0.ɵɵlistener("onNavClicked", function HeaderMainComponent_For_6_Template_shared_header_nav_item_onNavClicked_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNavClicked($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const nav_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("isActive", nav_r3.isActive)("title", nav_r3.title)("children", nav_r3.children);
  }
}
function HeaderMainMobileComponent_For_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "shared-header-mobile-nav-item", 17);
    i0.ɵɵlistener("onNavClicked", function HeaderMainMobileComponent_For_20_Template_shared_header_mobile_nav_item_onNavClicked_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNavClicked($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("isActive", item_r3.isActive)("title", item_r3.title)("children", item_r3.children);
  }
}
function HeaderMainMobileComponent_For_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", item_r4.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r4.title, " ");
  }
}
function HeaderMainMobileComponent_For_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵclassProp("active", item_r5.isActive);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", item_r5.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r5.title, " ");
  }
}
const _c2 = ["header"];
function HeaderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "shared-header-top")(1, "shared-header-main")(2, "shared-header-main-mobile");
  }
}
function HeaderComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "shared-header-base", 2);
  }
  if (rf & 2) {
    i0.ɵɵproperty("useBase", true);
  }
}
const HeaderType = {
  main: 'main',
  simple: 'simple',
  none: 'none',
  mini: 'mini'
};
const LangType = {
  ID: 'id',
  EN: 'en'
};
class HeaderService {
  platformId = inject(PLATFORM_ID);
  router = inject(Router);
  headerRef;
  /**
   * State
   */
  topLeftNavigation = new BehaviorSubject([]);
  topRightNavigation = new BehaviorSubject([]);
  logoUrl = new BehaviorSubject('');
  loginUrl = new BehaviorSubject('');
  mainNavigation = new BehaviorSubject([]);
  dropdownMenu = new BehaviorSubject({
    categories: [],
    productRecommendation: [],
    popularKeywords: []
  });
  lastSearch = new BehaviorSubject([]);
  /**
   * Attributes
   */
  headerType = new BehaviorSubject('main');
  langType = new BehaviorSubject('ID');
  setHeaderType(headerType) {
    this.headerType.next(headerType);
  }
  setLangType(langType) {
    this.langType.next(langType);
  }
  initMenu(config) {
    this.topLeftNavigation.next(config.topLeftnavigation);
    this.topRightNavigation.next(config.topRightNavigation);
    this.loginUrl.next(config.loginUrl);
    this.mainNavigation.next(config.mainNavigation);
    this.dropdownMenu.next(config.dropdownMenu);
  }
  setLogo(logoUrl) {
    this.logoUrl.next(logoUrl);
  }
  setLastSearch(lastSearchs) {
    this.lastSearch.next(lastSearchs);
  }
  static ɵfac = function HeaderService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HeaderService,
    factory: HeaderService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, {
    headerRef: [{
      type: ViewChild,
      args: ['header']
    }]
  });
})();
class HeaderTopComponent {
  /**
   * Injects
   */
  headerService = inject(HeaderService);
  /**
   * Bindings
   */
  topLeftNavigations = [{
    title: 'Personal',
    link: '#',
    isActive: true
  }, {
    title: 'Enterprise',
    link: '#',
    isActive: false
  }, {
    title: 'About Us',
    link: '#',
    isActive: false
  }];
  topRightNavigations = [{
    title: 'Tshop',
    link: '#'
  }, {
    title: 'Mytelkomsel',
    link: '#'
  }];
  /**
   * Attributes
   */
  languageNavigations = [{
    title: 'ID',
    isActive: true,
    imgSrc: 'assets/images/bahasa-indonesia.png',
    alt: 'Ganti Bahasa Indonesia'
  }, {
    title: 'EN',
    isActive: false,
    imgSrc: 'assets/images/english.png',
    alt: 'Change to English'
  }];
  ngOnInit() {
    this.headerService.langType.subscribe(langType => {
      this.languageNavigations.forEach(item => {
        item.isActive = false;
        if (item.title === langType) {
          item.isActive = true;
        }
      });
    });
    this.headerService.topLeftNavigation.subscribe(topLeftNavigations => {
      this.topLeftNavigations = topLeftNavigations;
    });
    this.headerService.topRightNavigation.subscribe(topRightNavigations => {
      this.topRightNavigations = topRightNavigations;
    });
  }
  changeLangHandler(lang) {
    this.headerService.setLangType(lang);
  }
  static ɵfac = function HeaderTopComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderTopComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderTopComponent,
    selectors: [["shared-header-top"]],
    inputs: {
      topLeftNavigations: "topLeftNavigations",
      topRightNavigations: "topRightNavigations"
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    decls: 13,
    vars: 0,
    consts: [[1, "header__top"], [1, "container"], ["aria-label", "Top Left Navigation", 1, "nav__top--left"], [1, "nav__group"], ["aria-label", "Top Right Navigation", 1, "nav__top--right"], [1, "nav__group--language"], [1, "nav-item", 3, "href"], [3, "click"], [3, "src", "alt"]],
    template: function HeaderTopComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 0)(1, "div", 1)(2, "nav", 2)(3, "ul", 3);
        i0.ɵɵrepeaterCreate(4, HeaderTopComponent_For_5_Template, 3, 4, "li", null, _forTrack0);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "nav", 4)(7, "ul", 3);
        i0.ɵɵrepeaterCreate(8, HeaderTopComponent_For_9_Template, 3, 2, "li", null, _forTrack0);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "section", 5);
        i0.ɵɵrepeaterCreate(11, HeaderTopComponent_For_12_Template, 4, 5, "button", null, _forTrack0);
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵrepeater(ctx.topLeftNavigations);
        i0.ɵɵadvance(4);
        i0.ɵɵrepeater(ctx.topRightNavigations);
        i0.ɵɵadvance(3);
        i0.ɵɵrepeater(ctx.languageNavigations);
      }
    },
    styles: [".header__top[_ngcontent-%COMP%]{display:none;background-color:#f6f3f3}@media (min-width: 1280px){.header__top[_ngcontent-%COMP%]{display:block}}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]{max-width:1440px;margin:0 auto;display:flex;justify-content:space-between;padding:0 1.5rem;height:3rem;text-transform:uppercase;font-size:13px;letter-spacing:.05em;font-family:poppins-regular,Arial,sans-serif;color:#001a41}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--left[_ngcontent-%COMP%]   .nav__group[_ngcontent-%COMP%], .header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group[_ngcontent-%COMP%]{display:flex;gap:2rem;height:100%}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--left[_ngcontent-%COMP%]   .nav__group[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%], .header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]{height:100%;display:flex;align-items:center;cursor:pointer}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--left[_ngcontent-%COMP%]   .nav__group[_ngcontent-%COMP%]   .nav-item.active[_ngcontent-%COMP%], .header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group[_ngcontent-%COMP%]   .nav-item.active[_ngcontent-%COMP%]{position:relative}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--left[_ngcontent-%COMP%]   .nav__group[_ngcontent-%COMP%]   .nav-item.active[_ngcontent-%COMP%]:after, .header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group[_ngcontent-%COMP%]   .nav-item.active[_ngcontent-%COMP%]:after{position:absolute;content:\"\";bottom:0;left:0;width:100%;height:2px;background-color:#ff0025}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]{display:flex;align-items:center;gap:3.5rem}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group[_ngcontent-%COMP%]{display:flex;gap:3.5rem;height:100%}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group--language[_ngcontent-%COMP%]{display:flex;align-items:center;gap:0;height:100%}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group--language[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{height:100%;display:flex;align-items:center;gap:.5rem;cursor:pointer;justify-content:center;padding:0 1rem}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group--language[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child{position:relative;padding-right:0}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group--language[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child:before{background-color:#99a0a7;position:absolute;content:\"\";left:0;height:30%;width:1px}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group--language[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{height:100%;display:flex;align-items:center;justify-content:center}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group--language[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span.active[_ngcontent-%COMP%]{position:relative}.header__top[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__top--right[_ngcontent-%COMP%]   .nav__group--language[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span.active[_ngcontent-%COMP%]:after{position:absolute;content:\"\";bottom:0;left:0;width:100%;height:2px;background-color:#ff0025}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderTopComponent, [{
    type: Component,
    args: [{
      selector: 'shared-header-top',
      standalone: true,
      imports: [],
      template: "<section class=\"header__top\">\r\n  <div class=\"container\">\r\n    <nav aria-label=\"Top Left Navigation\" class=\"nav__top--left\">\r\n      <ul class=\"nav__group\">\r\n        @for(nav of topLeftNavigations; track nav.title){\r\n        <li>\r\n          <a [class.active]=\"nav.isActive\" [href]=\"nav.link\" class=\"nav-item\">\r\n            {{ nav.title }}\r\n          </a>\r\n        </li>\r\n        }\r\n      </ul>\r\n    </nav>\r\n    <nav aria-label=\"Top Right Navigation\" class=\"nav__top--right\">\r\n      <ul class=\"nav__group\">\r\n        @for(nav of topRightNavigations; track nav.title){\r\n        <li>\r\n          <a [href]=\"nav.link\" class=\"nav-item\">\r\n            {{ nav.title }}\r\n          </a>\r\n        </li>\r\n        }\r\n      </ul>\r\n\r\n      <section class=\"nav__group--language\">\r\n        @for(lang of languageNavigations; track lang.title){\r\n        <button (click)=\"changeLangHandler(lang.title)\">\r\n          <img [src]=\"lang.imgSrc\" [alt]=\"lang.alt\" />\r\n          <span [class.active]=\"lang.isActive\"> {{ lang.title }} </span>\r\n        </button>\r\n        }\r\n      </section>\r\n    </nav>\r\n  </div>\r\n</section>\r\n",
      styles: [".header__top{display:none;background-color:#f6f3f3}@media (min-width: 1280px){.header__top{display:block}}.header__top .container{max-width:1440px;margin:0 auto;display:flex;justify-content:space-between;padding:0 1.5rem;height:3rem;text-transform:uppercase;font-size:13px;letter-spacing:.05em;font-family:poppins-regular,Arial,sans-serif;color:#001a41}.header__top .container .nav__top--left .nav__group,.header__top .container .nav__top--right .nav__group{display:flex;gap:2rem;height:100%}.header__top .container .nav__top--left .nav__group .nav-item,.header__top .container .nav__top--right .nav__group .nav-item{height:100%;display:flex;align-items:center;cursor:pointer}.header__top .container .nav__top--left .nav__group .nav-item.active,.header__top .container .nav__top--right .nav__group .nav-item.active{position:relative}.header__top .container .nav__top--left .nav__group .nav-item.active:after,.header__top .container .nav__top--right .nav__group .nav-item.active:after{position:absolute;content:\"\";bottom:0;left:0;width:100%;height:2px;background-color:#ff0025}.header__top .container .nav__top--right{display:flex;align-items:center;gap:3.5rem}.header__top .container .nav__top--right .nav__group{display:flex;gap:3.5rem;height:100%}.header__top .container .nav__top--right .nav__group--language{display:flex;align-items:center;gap:0;height:100%}.header__top .container .nav__top--right .nav__group--language button{height:100%;display:flex;align-items:center;gap:.5rem;cursor:pointer;justify-content:center;padding:0 1rem}.header__top .container .nav__top--right .nav__group--language button:last-child{position:relative;padding-right:0}.header__top .container .nav__top--right .nav__group--language button:last-child:before{background-color:#99a0a7;position:absolute;content:\"\";left:0;height:30%;width:1px}.header__top .container .nav__top--right .nav__group--language button span{height:100%;display:flex;align-items:center;justify-content:center}.header__top .container .nav__top--right .nav__group--language button span.active{position:relative}.header__top .container .nav__top--right .nav__group--language button span.active:after{position:absolute;content:\"\";bottom:0;left:0;width:100%;height:2px;background-color:#ff0025}\n"]
    }]
  }], null, {
    topLeftNavigations: [{
      type: Input
    }],
    topRightNavigations: [{
      type: Input
    }]
  });
})();
class HeaderMobileBottomComponent extends HeaderTopComponent {
  loginUrl = this.headerService.loginUrl.value;
  static ɵfac = /* @__PURE__ */(() => {
    let ɵHeaderMobileBottomComponent_BaseFactory;
    return function HeaderMobileBottomComponent_Factory(__ngFactoryType__) {
      return (ɵHeaderMobileBottomComponent_BaseFactory || (ɵHeaderMobileBottomComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HeaderMobileBottomComponent)))(__ngFactoryType__ || HeaderMobileBottomComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderMobileBottomComponent,
    selectors: [["shared-header-mobile-bottom"]],
    standalone: true,
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
    decls: 7,
    vars: 1,
    consts: [[1, "nav__bottom"], [1, "button__container"], ["aria-label", "Login Button", 1, "login__button"], [1, "button", 3, "href"], [3, "click"], [3, "src", "alt"]],
    template: function HeaderMobileBottomComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵrepeaterCreate(2, HeaderMobileBottomComponent_For_3_Template, 4, 5, "button", null, _forTrack0);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "nav", 2)(5, "a", 3);
        i0.ɵɵtext(6, "Login");
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.languageNavigations);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("href", ctx.loginUrl, i0.ɵɵsanitizeUrl);
      }
    },
    styles: [".nav__bottom[_ngcontent-%COMP%]{padding:1.25rem;background-color:#cccfd3;display:flex;width:100%;justify-content:space-between}.nav__bottom[_ngcontent-%COMP%]   .button__container[_ngcontent-%COMP%]{display:flex;align-items:center}.nav__bottom[_ngcontent-%COMP%]   .button__container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:3rem;height:2.5rem;display:flex;align-items:center;justify-content:center;flex-direction:column;font-family:poppins-regular,Arial,sans-serif;font-size:12px;gap:.25rem}.nav__bottom[_ngcontent-%COMP%]   .button__container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child{position:relative}.nav__bottom[_ngcontent-%COMP%]   .button__container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child:after{position:absolute;content:\"\";left:0;height:30%;width:1px;background-color:#99a0a7}.nav__bottom[_ngcontent-%COMP%]   .button__container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:1.5rem;width:1.5rem}.nav__bottom[_ngcontent-%COMP%]   .button__container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span.active[_ngcontent-%COMP%]{position:relative;width:100%;display:flex;align-items:end;justify-content:center}.nav__bottom[_ngcontent-%COMP%]   .button__container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span.active[_ngcontent-%COMP%]:after{position:absolute;content:\"\";bottom:0;width:50%;height:2px;background-color:#ff0025}.nav__bottom[_ngcontent-%COMP%]   .login__button[_ngcontent-%COMP%]{width:147px;height:56px;display:flex;align-items:center;justify-content:center;font-size:14px;font-family:poppins-bold,Arial,sans-serif;color:#fff;background-color:#ed0226;border-radius:9999px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderMobileBottomComponent, [{
    type: Component,
    args: [{
      selector: 'shared-header-mobile-bottom',
      standalone: true,
      imports: [],
      template: "<div class=\"nav__bottom\">\r\n  <div class=\"button__container\">\r\n    @for(lang of languageNavigations; track lang.title){\r\n    <button (click)=\"changeLangHandler(lang.title)\">\r\n      <img [src]=\"lang.imgSrc\" [alt]=\"lang.alt\" />\r\n      <span [class.active]=\"lang.isActive\"> {{ lang.title }} </span>\r\n    </button>\r\n    }\r\n  </div>\r\n\r\n  <nav aria-label=\"Login Button\" class=\"login__button\">\r\n    <a [href]=\"loginUrl\" class=\"button\">Login</a>\r\n  </nav>\r\n</div>\r\n",
      styles: [".nav__bottom{padding:1.25rem;background-color:#cccfd3;display:flex;width:100%;justify-content:space-between}.nav__bottom .button__container{display:flex;align-items:center}.nav__bottom .button__container button{width:3rem;height:2.5rem;display:flex;align-items:center;justify-content:center;flex-direction:column;font-family:poppins-regular,Arial,sans-serif;font-size:12px;gap:.25rem}.nav__bottom .button__container button:last-child{position:relative}.nav__bottom .button__container button:last-child:after{position:absolute;content:\"\";left:0;height:30%;width:1px;background-color:#99a0a7}.nav__bottom .button__container button img{height:1.5rem;width:1.5rem}.nav__bottom .button__container button span.active{position:relative;width:100%;display:flex;align-items:end;justify-content:center}.nav__bottom .button__container button span.active:after{position:absolute;content:\"\";bottom:0;width:50%;height:2px;background-color:#ff0025}.nav__bottom .login__button{width:147px;height:56px;display:flex;align-items:center;justify-content:center;font-size:14px;font-family:poppins-bold,Arial,sans-serif;color:#fff;background-color:#ed0226;border-radius:9999px}\n"]
    }]
  }], null, null);
})();
class HeaderNavFormComponent {
  /**
   * Injects
   */
  headerService = inject(HeaderService);
  router = inject(Router);
  platformId = inject(PLATFORM_ID);
  /**
   * Bindings
   */
  isOpen = true;
  onClose = new EventEmitter();
  searchValue = '';
  /**
   * Attributes
   */
  dropdownMenu = this.headerService.dropdownMenu.value;
  lastSearch = this.headerService.lastSearch.value;
  closeHandler() {
    this.onClose.emit();
  }
  ngOnChanges() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.isOpen) {
        this.searchValue = '';
        this.lastSearch = JSON.parse(localStorage.getItem('lastSearch') || '[]');
      }
    }
  }
  ngOnInit() {
    this.headerService.dropdownMenu.subscribe(dropdownMenu => {
      this.dropdownMenu = dropdownMenu;
    });
  }
  searchHandler(value) {
    if (isPlatformBrowser(this.platformId)) {
      if (value) {
        this.searchValue = value;
      }
      const url = '/search?search_api_fulltext=' + this.searchValue;
      let lastSearch = JSON.parse(localStorage.getItem('lastSearch') || '[]');
      if (lastSearch.length > 0) {
        const isExistIdx = lastSearch.findIndex(item => {
          return item.title === this.searchValue;
        });
        if (isExistIdx !== -1) {
          lastSearch.splice(isExistIdx, 1);
        }
      }
      const newValue = {
        title: this.searchValue,
        link: url
      };
      lastSearch = [newValue, ...lastSearch];
      if (lastSearch.length > 5) {
        lastSearch = lastSearch.slice(0, 5);
      }
      localStorage.setItem('lastSearch', JSON.stringify(lastSearch));
      window.location.href = url;
    }
  }
  static ɵfac = function HeaderNavFormComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderNavFormComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderNavFormComponent,
    selectors: [["shared-header-nav-form"]],
    inputs: {
      isOpen: "isOpen"
    },
    outputs: {
      onClose: "onClose"
    },
    standalone: true,
    features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
    decls: 7,
    vars: 2,
    consts: [[1, "search__form"], [3, "click"], ["src", "assets/images/search.png", "alt", ""], ["type", "text", "placeholder", "Search", 3, "keyup.enter", "ngModelChange", "ngModel"], ["src", "assets/images/close.png", "alt", "Close Search Form"], [1, "mega__menu"], [1, "mega__menu__container"], [1, "last__search"], [1, "empty"], [1, "popular__keywords"], [1, "prodcut__recommendation"], [1, "category"], [3, "click", "href"], ["src", "assets/images/clock.svg", "alt", "Last time"], [3, "href"], [3, "src", "alt"]],
    template: function HeaderNavFormComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function HeaderNavFormComponent_Template_button_click_1_listener() {
          return ctx.searchHandler();
        });
        i0.ɵɵelement(2, "img", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("keyup.enter", function HeaderNavFormComponent_Template_input_keyup_enter_3_listener() {
          return ctx.searchHandler();
        });
        i0.ɵɵtwoWayListener("ngModelChange", function HeaderNavFormComponent_Template_input_ngModelChange_3_listener($event) {
          i0.ɵɵtwoWayBindingSet(ctx.searchValue, $event) || (ctx.searchValue = $event);
          return $event;
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "button", 1);
        i0.ɵɵlistener("click", function HeaderNavFormComponent_Template_button_click_4_listener() {
          return ctx.closeHandler();
        });
        i0.ɵɵelement(5, "img", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(6, HeaderNavFormComponent_Conditional_6_Template, 27, 1, "div", 5);
      }
      if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtwoWayProperty("ngModel", ctx.searchValue);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.isOpen ? 6 : -1);
      }
    },
    dependencies: [FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel],
    styles: [".search__form[_ngcontent-%COMP%]{display:flex;align-items:center;padding:0 1rem;width:100%;height:3.5rem;background-color:#edecf0;border-radius:9999px;z-index:9999}.search__form[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100%;outline:none;border:none;background:none}.search__form[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline:none;border:none;border-style:none;border-color:transparent;box-shadow:none}.mega__menu[_ngcontent-%COMP%]{position:relative;width:100%}.mega__menu__container[_ngcontent-%COMP%]{position:absolute;width:100%;left:0;height:500px;overflow-y:scroll;overflow-x:hidden;box-shadow:0 4px 4px #edecf0;background-color:#fff;padding:2.5rem;border-bottom-left-radius:20px;border-bottom-right-radius:20px}.mega__menu__container[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.mega__menu__container[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:24px;font-family:telkomsel-batik-bold,Arial,sans-serif;margin-bottom:1rem}.mega__menu__container[_ngcontent-%COMP%]   .last__search[_ngcontent-%COMP%], .mega__menu__container[_ngcontent-%COMP%]   .popular__keywords[_ngcontent-%COMP%]{margin-bottom:2.5rem}.mega__menu__container[_ngcontent-%COMP%]   .popular__keywords[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:16px;margin-bottom:.5rem}.mega__menu__container[_ngcontent-%COMP%]   .prodcut__recommendation[_ngcontent-%COMP%]{margin-bottom:2.5rem}.mega__menu__container[_ngcontent-%COMP%]   .prodcut__recommendation[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{display:flex;gap:.75rem;height:100%;overflow-x:scroll}.mega__menu__container[_ngcontent-%COMP%]   .prodcut__recommendation[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.mega__menu__container[_ngcontent-%COMP%]   .prodcut__recommendation[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{min-width:190px}.mega__menu__container[_ngcontent-%COMP%]   .prodcut__recommendation[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{height:100%;width:100%}.mega__menu__container[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]{margin-bottom:2.5rem}.mega__menu__container[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;gap:.75rem}.mega__menu__container[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{width:6rem;font-size:16px;margin-bottom:.5rem;padding-inline:1rem;border:1px solid #cccfd3;border-radius:.75rem;display:flex;flex-direction:column;align-items:center;gap:.25rem;cursor:pointer}.mega__menu__container[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:3rem;width:100%}.mega__menu__container[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-size:16px;font-family:telkomsel-batik-bold,Arial,sans-serif}.mega__menu__container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.empty[_ngcontent-%COMP%]:hover{color:#001a41}.mega__menu__container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{color:#ed0226}.mega__menu__container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:flex;align-items:center;gap:.25rem}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderNavFormComponent, [{
    type: Component,
    args: [{
      selector: 'shared-header-nav-form',
      standalone: true,
      imports: [FormsModule],
      template: "<div class=\"search__form\">\r\n  <button (click)=\"searchHandler()\">\r\n    <img src=\"assets/images/search.png\" alt=\"\" />\r\n  </button>\r\n  <input\r\n    (keyup.enter)=\"searchHandler()\"\r\n    type=\"text\"\r\n    placeholder=\"Search\"\r\n    [(ngModel)]=\"searchValue\"\r\n  />\r\n  <button (click)=\"closeHandler()\">\r\n    <img src=\"assets/images/close.png\" alt=\"Close Search Form\" />\r\n  </button>\r\n</div>\r\n\r\n@if(isOpen){\r\n<div class=\"mega__menu\">\r\n  <div class=\"mega__menu__container\">\r\n    <div class=\"last__search\">\r\n      <h3>Last Search</h3>\r\n      <ul>\r\n        @for (item of lastSearch; track $index) {\r\n        <li>\r\n          <a [href]=\"item.link\" (click)=\"searchHandler(item.title)\">\r\n            <img src=\"assets/images/clock.svg\" alt=\"Last time\" />\r\n            <span>{{ item.title }}</span>\r\n          </a>\r\n        </li>\r\n        } @empty {\r\n        <li class=\"empty\">\r\n          <span>Last search is empty.</span>\r\n        </li>\r\n        }\r\n      </ul>\r\n    </div>\r\n\r\n    <div class=\"popular__keywords\">\r\n      <h3>Popular Keywords</h3>\r\n      <ul>\r\n        @for(key of dropdownMenu.popularKeywords; track key.title){\r\n        <li>\r\n          <a [href]=\"key.link\">{{ key.title }}</a>\r\n        </li>\r\n        }\r\n      </ul>\r\n    </div>\r\n\r\n    <div class=\"prodcut__recommendation\">\r\n      <h3>Product Recommendation</h3>\r\n      <ul>\r\n        @for (item of dropdownMenu.productRecommendation; track $index) {\r\n        <li>\r\n          <a [href]=\"item.link\">\r\n            <img [src]=\"item.imageSrc\" [alt]=\"item.alt\" />\r\n          </a>\r\n        </li>\r\n        }\r\n      </ul>\r\n    </div>\r\n\r\n    <div class=\"category\">\r\n      <h3>Category</h3>\r\n      <ul>\r\n        @for(item of dropdownMenu.categories; track item.alt){\r\n        <li>\r\n          <a [href]=\"item.link\"\r\n            ><img [src]=\"item.imageSrc\" [alt]=\"item.alt\" />\r\n            <h4>{{ item.alt }}</h4>\r\n          </a>\r\n        </li>\r\n        }\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</div>\r\n}\r\n",
      styles: [".search__form{display:flex;align-items:center;padding:0 1rem;width:100%;height:3.5rem;background-color:#edecf0;border-radius:9999px;z-index:9999}.search__form input{width:100%;outline:none;border:none;background:none}.search__form input:focus{outline:none;border:none;border-style:none;border-color:transparent;box-shadow:none}.mega__menu{position:relative;width:100%}.mega__menu__container{position:absolute;width:100%;left:0;height:500px;overflow-y:scroll;overflow-x:hidden;box-shadow:0 4px 4px #edecf0;background-color:#fff;padding:2.5rem;border-bottom-left-radius:20px;border-bottom-right-radius:20px}.mega__menu__container::-webkit-scrollbar{display:none}.mega__menu__container h3{font-size:24px;font-family:telkomsel-batik-bold,Arial,sans-serif;margin-bottom:1rem}.mega__menu__container .last__search,.mega__menu__container .popular__keywords{margin-bottom:2.5rem}.mega__menu__container .popular__keywords ul li{font-size:16px;margin-bottom:.5rem}.mega__menu__container .prodcut__recommendation{margin-bottom:2.5rem}.mega__menu__container .prodcut__recommendation ul{display:flex;gap:.75rem;height:100%;overflow-x:scroll}.mega__menu__container .prodcut__recommendation ul::-webkit-scrollbar{display:none}.mega__menu__container .prodcut__recommendation ul li{min-width:190px}.mega__menu__container .prodcut__recommendation ul li a{height:100%;width:100%}.mega__menu__container .category{margin-bottom:2.5rem}.mega__menu__container .category ul{display:flex;flex-wrap:wrap;gap:.75rem}.mega__menu__container .category ul li a{width:6rem;font-size:16px;margin-bottom:.5rem;padding-inline:1rem;border:1px solid #cccfd3;border-radius:.75rem;display:flex;flex-direction:column;align-items:center;gap:.25rem;cursor:pointer}.mega__menu__container .category ul li a img{height:3rem;width:100%}.mega__menu__container .category ul li a h4{font-size:16px;font-family:telkomsel-batik-bold,Arial,sans-serif}.mega__menu__container ul li.empty:hover{color:#001a41}.mega__menu__container ul li:hover{color:#ed0226}.mega__menu__container ul li a{display:flex;align-items:center;gap:.25rem}\n"]
    }]
  }], null, {
    isOpen: [{
      type: Input
    }],
    onClose: [{
      type: Output
    }]
  });
})();
class HeaderBaseComponent {
  /**
   * Injects
   */
  headerService = inject(HeaderService);
  /**
   * Bindings
   */
  useBase = true;
  customClass = '';
  /**
   * Attributes
   */
  logoUrl = this.headerService.logoUrl.value || 'assets/images/tsel.png';
  ngOnInit() {
    this.headerService.logoUrl.subscribe(logoUrl => {
      this.logoUrl = logoUrl || 'assets/images/tsel.png';
    });
  }
  static ɵfac = function HeaderBaseComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderBaseComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderBaseComponent,
    selectors: [["shared-header-base"]],
    inputs: {
      useBase: "useBase",
      customClass: [0, "class", "customClass"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c0,
    decls: 6,
    vars: 6,
    consts: [[3, "ngClass"], [1, "container"], ["routerLink", "/", 1, "logo"], ["alt", "Telkomsel", 3, "src"], [1, "container__content"]],
    template: function HeaderBaseComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "section", 0)(1, "div", 1)(2, "a", 2);
        i0.ɵɵelement(3, "img", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵprojection(5);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("header__base--base", ctx.useBase);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1, ctx.customClass));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("src", ctx.logoUrl, i0.ɵɵsanitizeUrl);
      }
    },
    dependencies: [RouterModule, i1$1.RouterLink, NgClass],
    styles: [".header__base[_ngcontent-%COMP%]{background-color:#fff;width:100%}.header__base--base[_ngcontent-%COMP%]{border-bottom:1px solid #cccfd3;width:100%}@media (min-width: 1024px){.header__base--base[_ngcontent-%COMP%]{padding:0 1.25rem}}.header__base[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]{width:100%;max-width:1440px;margin:0 auto;display:flex;justify-content:space-between;height:3.5rem;font-size:13px;letter-spacing:.05em;color:#001a41;align-items:center;font-family:poppins-regular,Arial,sans-serif}.header__base[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:2.25rem;padding-left:.5rem;object-fit:contain}@media (min-width: 1280px){.header__base[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{padding-left:1rem}}.header__base[_ngcontent-%COMP%]   .container__content[_ngcontent-%COMP%]{display:flex;align-items:center;padding-right:1.5rem;width:100%}@media (min-width: 1280px){.header__base[_ngcontent-%COMP%]   .container__content[_ngcontent-%COMP%]{padding-right:2rem}}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderBaseComponent, [{
    type: Component,
    args: [{
      selector: 'shared-header-base',
      standalone: true,
      imports: [RouterModule, NgClass],
      template: "<section\r\n  [ngClass]=\"['header__base', customClass]\"\r\n  [class.header__base--base]=\"useBase\"\r\n>\r\n  <div class=\"container\">\r\n    <a class=\"logo\" routerLink=\"/\"><img [src]=\"logoUrl\" alt=\"Telkomsel\" /></a>\r\n\r\n    <div class=\"container__content\">\r\n      <ng-content></ng-content>\r\n    </div>\r\n  </div>\r\n</section>\r\n",
      styles: [".header__base{background-color:#fff;width:100%}.header__base--base{border-bottom:1px solid #cccfd3;width:100%}@media (min-width: 1024px){.header__base--base{padding:0 1.25rem}}.header__base .container{width:100%;max-width:1440px;margin:0 auto;display:flex;justify-content:space-between;height:3.5rem;font-size:13px;letter-spacing:.05em;color:#001a41;align-items:center;font-family:poppins-regular,Arial,sans-serif}.header__base .container .logo img{height:2.25rem;padding-left:.5rem;object-fit:contain}@media (min-width: 1280px){.header__base .container .logo img{padding-left:1rem}}.header__base .container__content{display:flex;align-items:center;padding-right:1.5rem;width:100%}@media (min-width: 1280px){.header__base .container__content{padding-right:2rem}}\n"]
    }]
  }], null, {
    useBase: [{
      type: Input
    }],
    customClass: [{
      type: Input,
      args: ['class']
    }]
  });
})();
class HeaderMobileNavFormComponent extends HeaderNavFormComponent {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵHeaderMobileNavFormComponent_BaseFactory;
    return function HeaderMobileNavFormComponent_Factory(__ngFactoryType__) {
      return (ɵHeaderMobileNavFormComponent_BaseFactory || (ɵHeaderMobileNavFormComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HeaderMobileNavFormComponent)))(__ngFactoryType__ || HeaderMobileNavFormComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderMobileNavFormComponent,
    selectors: [["shared-header-mobile-nav-form"]],
    standalone: true,
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
    decls: 37,
    vars: 6,
    consts: [[1, "overlay--form", 3, "click"], [1, "nav__form__mobile"], [1, "wrapper"], [1, "header__main__mobile"], [3, "click"], ["src", "assets/images/close.png", "alt", ""], [1, "form__menu"], [1, "form"], [1, "form__group"], ["src", "assets/images/search.png", "alt", "Search"], ["type", "text", "placeholder", "Search", 3, "keyup.enter", "ngModelChange", "ngModel"], [1, "last__search"], [1, "empty"], [1, "popular__keywords"], [1, "prodcut__recommendation"], [1, "category"], [3, "href"], ["src", "assets/images/clock.svg", "alt", "Last time"], [3, "src", "alt"]],
    template: function HeaderMobileNavFormComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function HeaderMobileNavFormComponent_Template_div_click_0_listener() {
          return ctx.closeHandler();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "shared-header-base", 2)(3, "section", 3)(4, "button", 4);
        i0.ɵɵlistener("click", function HeaderMobileNavFormComponent_Template_button_click_4_listener() {
          return ctx.closeHandler();
        });
        i0.ɵɵelement(5, "img", 5);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 6)(7, "div", 7)(8, "div", 8)(9, "button", 4);
        i0.ɵɵlistener("click", function HeaderMobileNavFormComponent_Template_button_click_9_listener() {
          return ctx.searchHandler();
        });
        i0.ɵɵelement(10, "img", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "input", 10);
        i0.ɵɵlistener("keyup.enter", function HeaderMobileNavFormComponent_Template_input_keyup_enter_11_listener() {
          return ctx.searchHandler();
        });
        i0.ɵɵtwoWayListener("ngModelChange", function HeaderMobileNavFormComponent_Template_input_ngModelChange_11_listener($event) {
          i0.ɵɵtwoWayBindingSet(ctx.searchValue, $event) || (ctx.searchValue = $event);
          return $event;
        });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(12, "div", 11)(13, "h3");
        i0.ɵɵtext(14, "Last Search");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "ul");
        i0.ɵɵrepeaterCreate(16, HeaderMobileNavFormComponent_For_17_Template, 4, 2, "li", null, i0.ɵɵrepeaterTrackByIndex, false, HeaderMobileNavFormComponent_ForEmpty_18_Template, 2, 0, "li", 12);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(19, "div", 13)(20, "h3");
        i0.ɵɵtext(21, "Popular Keywords");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "ul");
        i0.ɵɵrepeaterCreate(23, HeaderMobileNavFormComponent_For_24_Template, 3, 2, "li", null, _forTrack0);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(25, "div", 14)(26, "h3");
        i0.ɵɵtext(27, "Product Recommendation");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "ul");
        i0.ɵɵrepeaterCreate(29, HeaderMobileNavFormComponent_For_30_Template, 3, 3, "li", null, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(31, "div", 15)(32, "h3");
        i0.ɵɵtext(33, "Category");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "ul");
        i0.ɵɵrepeaterCreate(35, HeaderMobileNavFormComponent_For_36_Template, 5, 4, "li", null, _forTrack1);
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("opened", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("opened", ctx.isOpen);
        i0.ɵɵadvance(10);
        i0.ɵɵtwoWayProperty("ngModel", ctx.searchValue);
        i0.ɵɵadvance(5);
        i0.ɵɵrepeater(ctx.lastSearch);
        i0.ɵɵadvance(7);
        i0.ɵɵrepeater(ctx.dropdownMenu.popularKeywords);
        i0.ɵɵadvance(6);
        i0.ɵɵrepeater(ctx.dropdownMenu.productRecommendation);
        i0.ɵɵadvance(6);
        i0.ɵɵrepeater(ctx.dropdownMenu.categories);
      }
    },
    dependencies: [HeaderBaseComponent, FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel],
    styles: [".nav__form__mobile[_ngcontent-%COMP%]{position:absolute;top:0;left:-110%;width:100%;height:100vh;z-index:9999;transition:all .3s ease-in-out}.nav__form__mobile.opened[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:50;overflow-y:scroll}.nav__form__mobile[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]{display:flex;width:100%}@media (min-width: 1280px){.nav__form__mobile[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]{display:none}}.nav__form__mobile[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]   .header__main__mobile[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:end;height:3.5rem;width:100%;gap:1rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]{background-color:#fff;padding-bottom:5rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]{padding:1.25rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .form__group[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;gap:1rem;background-color:#edecf0;border-radius:9999px;padding:.5rem 1rem;color:#001a41}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .form__group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100%;background:none;outline:none;box-shadow:none;border:none}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .form[_ngcontent-%COMP%]   .form__group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline:none;border:none;border-style:none;border-color:transparent;box-shadow:none}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:16px;font-family:telkomsel-batik-bold,Arial,sans-serif;margin-bottom:1rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .last__search[_ngcontent-%COMP%]{margin-bottom:2.5rem;padding-left:1.25rem;padding-right:1.25rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .last__search[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:flex;align-items:center;gap:.25rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .popular__keywords[_ngcontent-%COMP%]{margin-bottom:2.5rem;padding-left:1.25rem;padding-right:1.25rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .popular__keywords[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:16px;margin-bottom:.5rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .prodcut__recommendation[_ngcontent-%COMP%]{margin-bottom:2.5rem;padding-left:1.25rem;padding-right:1.25rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .prodcut__recommendation[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{display:flex;gap:.75rem;height:100%;overflow-x:scroll}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .prodcut__recommendation[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .prodcut__recommendation[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{min-width:150px}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .prodcut__recommendation[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{height:100%;width:100%}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]{margin-bottom:2.5rem;padding-left:1.25rem;padding-right:1.25rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;gap:.75rem}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{width:6rem;font-size:16px;margin-bottom:.5rem;padding:1rem;border:1px solid #cccfd3;border-radius:.75rem;display:flex;flex-direction:column;align-items:center;gap:.25rem;cursor:pointer}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:3rem;width:100%}.nav__form__mobile[_ngcontent-%COMP%]   .form__menu[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-size:16px;font-family:telkomsel-batik-bold,Arial,sans-serif}.overlay--form[_ngcontent-%COMP%]{display:none}.overlay--form.opened[_ngcontent-%COMP%]{display:block;position:fixed;top:0;left:0;width:100%;height:100vh;background-color:#0000003f}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderMobileNavFormComponent, [{
    type: Component,
    args: [{
      selector: 'shared-header-mobile-nav-form',
      standalone: true,
      imports: [HeaderBaseComponent, FormsModule],
      template: "<div\r\n  class=\"overlay--form\"\r\n  [class.opened]=\"isOpen\"\r\n  (click)=\"closeHandler()\"\r\n></div>\r\n\r\n<div class=\"nav__form__mobile\" [class.opened]=\"isOpen\">\r\n  <shared-header-base class=\"wrapper\">\r\n    <section class=\"header__main__mobile\">\r\n      <button (click)=\"closeHandler()\">\r\n        <img src=\"assets/images/close.png\" alt=\"\" />\r\n      </button>\r\n    </section>\r\n  </shared-header-base>\r\n\r\n  <div class=\"form__menu\">\r\n    <div class=\"form\">\r\n      <div class=\"form__group\">\r\n        <button (click)=\"searchHandler()\">\r\n          <img src=\"assets/images/search.png\" alt=\"Search\" />\r\n        </button>\r\n        <input\r\n          (keyup.enter)=\"searchHandler()\"\r\n          [(ngModel)]=\"searchValue\"\r\n          type=\"text\"\r\n          placeholder=\"Search\"\r\n        />\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"last__search\">\r\n      <h3>Last Search</h3>\r\n      <ul>\r\n        @for (item of lastSearch; track $index) {\r\n        <li>\r\n          <a href=\"{{ item.link }}\"\r\n            ><img src=\"assets/images/clock.svg\" alt=\"Last time\" />\r\n            {{ item.title }}</a\r\n          >\r\n        </li>\r\n        } @empty {\r\n        <li class=\"empty\">No Last Search</li>\r\n        }\r\n      </ul>\r\n    </div>\r\n\r\n    <div class=\"popular__keywords\">\r\n      <h3>Popular Keywords</h3>\r\n      <ul>\r\n        @for(key of dropdownMenu.popularKeywords; track key.title){\r\n        <li>\r\n          <a [href]=\"key.link\">{{ key.title }}</a>\r\n        </li>\r\n        }\r\n      </ul>\r\n    </div>\r\n\r\n    <div class=\"prodcut__recommendation\">\r\n      <h3>Product Recommendation</h3>\r\n      <ul>\r\n        @for (item of dropdownMenu.productRecommendation; track $index) {\r\n        <li>\r\n          <a [href]=\"item.link\">\r\n            <img [src]=\"item.imageSrc\" [alt]=\"item.alt\" />\r\n          </a>\r\n        </li>\r\n        }\r\n      </ul>\r\n    </div>\r\n\r\n    <div class=\"category\">\r\n      <h3>Category</h3>\r\n      <ul>\r\n        @for(item of dropdownMenu.categories; track item.alt){\r\n        <li>\r\n          <a [href]=\"item.link\"\r\n            ><img [src]=\"item.imageSrc\" [alt]=\"item.alt\" />\r\n            <h4>{{ item.alt }}</h4>\r\n          </a>\r\n        </li>\r\n        }\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
      styles: [".nav__form__mobile{position:absolute;top:0;left:-110%;width:100%;height:100vh;z-index:9999;transition:all .3s ease-in-out}.nav__form__mobile.opened{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:50;overflow-y:scroll}.nav__form__mobile .wrapper{display:flex;width:100%}@media (min-width: 1280px){.nav__form__mobile .wrapper{display:none}}.nav__form__mobile .wrapper .header__main__mobile{display:flex;align-items:center;justify-content:end;height:3.5rem;width:100%;gap:1rem}.nav__form__mobile .form__menu{background-color:#fff;padding-bottom:5rem}.nav__form__mobile .form__menu .form{padding:1.25rem}.nav__form__mobile .form__menu .form .form__group{display:flex;align-items:center;justify-content:center;gap:1rem;background-color:#edecf0;border-radius:9999px;padding:.5rem 1rem;color:#001a41}.nav__form__mobile .form__menu .form .form__group input{width:100%;background:none;outline:none;box-shadow:none;border:none}.nav__form__mobile .form__menu .form .form__group input:focus{outline:none;border:none;border-style:none;border-color:transparent;box-shadow:none}.nav__form__mobile .form__menu h3{font-size:16px;font-family:telkomsel-batik-bold,Arial,sans-serif;margin-bottom:1rem}.nav__form__mobile .form__menu .last__search{margin-bottom:2.5rem;padding-left:1.25rem;padding-right:1.25rem}.nav__form__mobile .form__menu .last__search ul li a{display:flex;align-items:center;gap:.25rem}.nav__form__mobile .form__menu .popular__keywords{margin-bottom:2.5rem;padding-left:1.25rem;padding-right:1.25rem}.nav__form__mobile .form__menu .popular__keywords ul li{font-size:16px;margin-bottom:.5rem}.nav__form__mobile .form__menu .prodcut__recommendation{margin-bottom:2.5rem;padding-left:1.25rem;padding-right:1.25rem}.nav__form__mobile .form__menu .prodcut__recommendation ul{display:flex;gap:.75rem;height:100%;overflow-x:scroll}.nav__form__mobile .form__menu .prodcut__recommendation ul::-webkit-scrollbar{display:none}.nav__form__mobile .form__menu .prodcut__recommendation ul li{min-width:150px}.nav__form__mobile .form__menu .prodcut__recommendation ul li a{height:100%;width:100%}.nav__form__mobile .form__menu .category{margin-bottom:2.5rem;padding-left:1.25rem;padding-right:1.25rem}.nav__form__mobile .form__menu .category ul{display:flex;flex-wrap:wrap;gap:.75rem}.nav__form__mobile .form__menu .category ul li a{width:6rem;font-size:16px;margin-bottom:.5rem;padding:1rem;border:1px solid #cccfd3;border-radius:.75rem;display:flex;flex-direction:column;align-items:center;gap:.25rem;cursor:pointer}.nav__form__mobile .form__menu .category ul li a img{height:3rem;width:100%}.nav__form__mobile .form__menu .category ul li a h4{font-size:16px;font-family:telkomsel-batik-bold,Arial,sans-serif}.overlay--form{display:none}.overlay--form.opened{display:block;position:fixed;top:0;left:0;width:100%;height:100vh;background-color:#0000003f}\n"]
    }]
  }], null, null);
})();
class HeaderNavItemComponent {
  isActive = false;
  title = '';
  children = [];
  onNavClicked = new EventEmitter();
  buttonClickHandler(value) {
    this.onNavClicked.emit(value);
  }
  static ɵfac = function HeaderNavItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderNavItemComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderNavItemComponent,
    selectors: [["shared-header-nav-item"]],
    inputs: {
      isActive: "isActive",
      title: "title",
      children: "children"
    },
    outputs: {
      onNavClicked: "onNavClicked"
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    decls: 9,
    vars: 9,
    consts: [[3, "click"], ["src", "assets/images/chevron.png", "alt", "", 1, "transition-all", "duration-200"], [1, "overflow__container"], [1, "dropdown"], [1, "dropdown__menu"], [3, "href"]],
    template: function HeaderNavItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function HeaderNavItemComponent_Template_button_click_0_listener() {
          return ctx.buttonClickHandler(ctx.title);
        });
        i0.ɵɵtext(1);
        i0.ɵɵelement(2, "img", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2)(4, "div", 0);
        i0.ɵɵlistener("click", function HeaderNavItemComponent_Template_div_click_4_listener() {
          return ctx.buttonClickHandler(ctx.title);
        });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 3)(6, "ul", 4);
        i0.ɵɵrepeaterCreate(7, HeaderNavItemComponent_For_8_Template, 3, 2, "li", null, _forTrack0);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("active", ctx.isActive);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance();
        i0.ɵɵclassProp("rotate-180", ctx.isActive);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("overlay", ctx.isActive);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("active", ctx.isActive);
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.children);
      }
    },
    styles: ["button[_ngcontent-%COMP%]{display:flex;height:3.5rem;align-items:center;justify-content:center;cursor:pointer;font-family:poppins-regular,Arial,sans-serif;font-weight:600;position:relative}button[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-left:.75rem}button[_ngcontent-%COMP%]:hover, button.active[_ngcontent-%COMP%]{color:#ff0025}button[_ngcontent-%COMP%]:hover:after, button.active[_ngcontent-%COMP%]:after{position:absolute;content:\"\";bottom:0;left:0;width:100%;height:2px;background-color:#ff0025}.overflow__container[_ngcontent-%COMP%]{overflow:hidden}.overflow__container[_ngcontent-%COMP%]   .overlay[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100vh;z-index:-10}.dropdown[_ngcontent-%COMP%]{position:relative;display:none;justify-content:center}.dropdown.active[_ngcontent-%COMP%]{display:flex}.dropdown[_ngcontent-%COMP%]   .dropdown__menu[_ngcontent-%COMP%]{position:absolute;top:1rem;padding:1.5rem;width:14rem;background-color:#fff;font-family:poppins-light,Arial,sans-serif;font-size:16px;box-shadow:0 4px 4px #00000013;border-bottom-left-radius:4px;border-bottom-right-radius:4px}.dropdown[_ngcontent-%COMP%]   .dropdown__menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-bottom:1.5rem;color:#001a41}.dropdown[_ngcontent-%COMP%]   .dropdown__menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{color:#ff0025;text-decoration-line:underline}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderNavItemComponent, [{
    type: Component,
    args: [{
      selector: 'shared-header-nav-item',
      standalone: true,
      imports: [],
      template: "<button (click)=\"buttonClickHandler(title)\" [class.active]=\"isActive\">\r\n  {{ title }}\r\n  <img\r\n    class=\"transition-all duration-200\"\r\n    [class.rotate-180]=\"isActive\"\r\n    src=\"assets/images/chevron.png\"\r\n    alt=\"\"\r\n  />\r\n</button>\r\n<div class=\"overflow__container\">\r\n  <div (click)=\"buttonClickHandler(title)\" [class.overlay]=\"isActive\"></div>\r\n</div>\r\n<div class=\"dropdown\" [class.active]=\"isActive\">\r\n  <ul class=\"dropdown__menu\">\r\n    @for(child of children; track child.title){\r\n    <li>\r\n      <a [href]=\"child.link\">{{ child.title }}</a>\r\n    </li>\r\n    }\r\n  </ul>\r\n</div>\r\n",
      styles: ["button{display:flex;height:3.5rem;align-items:center;justify-content:center;cursor:pointer;font-family:poppins-regular,Arial,sans-serif;font-weight:600;position:relative}button img{margin-left:.75rem}button:hover,button.active{color:#ff0025}button:hover:after,button.active:after{position:absolute;content:\"\";bottom:0;left:0;width:100%;height:2px;background-color:#ff0025}.overflow__container{overflow:hidden}.overflow__container .overlay{position:absolute;top:0;left:0;width:100%;height:100vh;z-index:-10}.dropdown{position:relative;display:none;justify-content:center}.dropdown.active{display:flex}.dropdown .dropdown__menu{position:absolute;top:1rem;padding:1.5rem;width:14rem;background-color:#fff;font-family:poppins-light,Arial,sans-serif;font-size:16px;box-shadow:0 4px 4px #00000013;border-bottom-left-radius:4px;border-bottom-right-radius:4px}.dropdown .dropdown__menu li{margin-bottom:1.5rem;color:#001a41}.dropdown .dropdown__menu li:hover{color:#ff0025;text-decoration-line:underline}\n"]
    }]
  }], null, {
    isActive: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    children: [{
      type: Input
    }],
    onNavClicked: [{
      type: Output
    }]
  });
})();
class HeaderMobileNavItemComponent extends HeaderNavItemComponent {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵHeaderMobileNavItemComponent_BaseFactory;
    return function HeaderMobileNavItemComponent_Factory(__ngFactoryType__) {
      return (ɵHeaderMobileNavItemComponent_BaseFactory || (ɵHeaderMobileNavItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HeaderMobileNavItemComponent)))(__ngFactoryType__ || HeaderMobileNavItemComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderMobileNavItemComponent,
    selectors: [["shared-header-mobile-nav-item"]],
    standalone: true,
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
    decls: 7,
    vars: 7,
    consts: [[3, "click"], ["src", "assets/images/chevron.png", "alt", ""], [1, "wrapper"], [1, "dropdown__menu"], [3, "href"]],
    template: function HeaderMobileNavItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function HeaderMobileNavItemComponent_Template_button_click_0_listener() {
          return ctx.buttonClickHandler(ctx.title);
        });
        i0.ɵɵtext(1);
        i0.ɵɵelement(2, "img", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2)(4, "ul", 3);
        i0.ɵɵrepeaterCreate(5, HeaderMobileNavItemComponent_For_6_Template, 3, 2, "li", null, _forTrack0);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("active", ctx.isActive);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance();
        i0.ɵɵclassProp("active", ctx.isActive);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("opened", ctx.isActive);
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.children);
      }
    },
    styles: ["button[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;height:3.5rem;font-weight:600;font-size:20px;font-family:telkomsel-batik-bold,Arial,sans-serif;color:#001a41;width:100%;padding:0 1.25rem}button.active[_ngcontent-%COMP%]{color:#ff0025}button[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{transition:all .3s ease-in-out}button[_ngcontent-%COMP%]   img.active[_ngcontent-%COMP%]{transform:rotate(180deg)}.wrapper[_ngcontent-%COMP%]   .dropdown__menu[_ngcontent-%COMP%]{width:100%;padding:0 4rem;display:none}.wrapper[_ngcontent-%COMP%]   .dropdown__menu.opened[_ngcontent-%COMP%]{margin-bottom:1.75rem;display:block}.wrapper[_ngcontent-%COMP%]   .dropdown__menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-top:1.5rem;font-family:poppins-light,Arial,sans-serif;font-size:14px;color:#001a41}.wrapper[_ngcontent-%COMP%]   .dropdown__menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child{margin-top:.5rem}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderMobileNavItemComponent, [{
    type: Component,
    args: [{
      selector: 'shared-header-mobile-nav-item',
      standalone: true,
      imports: [],
      template: "<button (click)=\"buttonClickHandler(title)\" [class.active]=\"isActive\">\r\n  {{ title }}\r\n  <img [class.active]=\"isActive\" src=\"assets/images/chevron.png\" alt=\"\" />\r\n</button>\r\n\r\n<div class=\"wrapper\">\r\n  <ul class=\"dropdown__menu\" [class.opened]=\"isActive\">\r\n    @for(child of children; track child.title){\r\n    <li>\r\n      <a [href]=\"child.link\">{{ child.title }}</a>\r\n    </li>\r\n    }\r\n  </ul>\r\n</div>\r\n",
      styles: ["button{display:flex;align-items:center;justify-content:space-between;height:3.5rem;font-weight:600;font-size:20px;font-family:telkomsel-batik-bold,Arial,sans-serif;color:#001a41;width:100%;padding:0 1.25rem}button.active{color:#ff0025}button img{transition:all .3s ease-in-out}button img.active{transform:rotate(180deg)}.wrapper .dropdown__menu{width:100%;padding:0 4rem;display:none}.wrapper .dropdown__menu.opened{margin-bottom:1.75rem;display:block}.wrapper .dropdown__menu li{margin-top:1.5rem;font-family:poppins-light,Arial,sans-serif;font-size:14px;color:#001a41}.wrapper .dropdown__menu li:first-child{margin-top:.5rem}\n"]
    }]
  }], null, null);
})();
class HeaderMainComponent {
  headerService = inject(HeaderService);
  isFormDisplayed = false;
  mainNavigation = [];
  loginUrl = this.headerService.loginUrl.value;
  ngOnInit() {
    this.headerService.mainNavigation.subscribe(mainNavigation => {
      this.mainNavigation = mainNavigation;
    });
  }
  onFormClose() {
    this.isFormDisplayed = false;
  }
  formOpenHandler() {
    this.isFormDisplayed = true;
  }
  onNavClicked(value) {
    this.headerService.mainNavigation.value.forEach(item => {
      if (item.title === value) {
        item.isActive = !item.isActive;
      } else {
        item.isActive = false;
      }
    });
  }
  static ɵfac = function HeaderMainComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderMainComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderMainComponent,
    selectors: [["shared-header-main"]],
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    decls: 14,
    vars: 7,
    consts: [[1, "wrapper", 3, "useBase"], [1, "header__main"], [1, "container"], ["aria-label", "Main Navigation", 1, "nav__main"], [1, "nav__group"], [1, "search__form", 3, "onClose", "isOpen"], [1, "search__bar"], [3, "click"], ["src", "assets/images/search.png", "alt", ""], ["aria-label", "Login Button", 1, "login__button"], [1, "button", 3, "href"], [3, "onNavClicked", "isActive", "title", "children"]],
    template: function HeaderMainComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "shared-header-base", 0)(1, "section", 1)(2, "div", 2)(3, "nav", 3)(4, "ul", 4);
        i0.ɵɵrepeaterCreate(5, HeaderMainComponent_For_6_Template, 2, 3, "li", null, _forTrack0);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "shared-header-nav-form", 5);
        i0.ɵɵlistener("onClose", function HeaderMainComponent_Template_shared_header_nav_form_onClose_7_listener() {
          return ctx.onFormClose();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6)(9, "button", 7);
        i0.ɵɵlistener("click", function HeaderMainComponent_Template_button_click_9_listener() {
          return ctx.formOpenHandler();
        });
        i0.ɵɵelement(10, "img", 8);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(11, "nav", 9)(12, "a", 10);
        i0.ɵɵtext(13, "Sign In");
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("useBase", false);
        i0.ɵɵadvance(5);
        i0.ɵɵrepeater(ctx.mainNavigation);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("opened", ctx.isFormDisplayed);
        i0.ɵɵproperty("isOpen", ctx.isFormDisplayed);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("hiddened", ctx.isFormDisplayed);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("href", ctx.loginUrl, i0.ɵɵsanitizeUrl);
      }
    },
    dependencies: [HeaderBaseComponent, HeaderNavFormComponent, HeaderNavItemComponent],
    styles: [".wrapper[_ngcontent-%COMP%]{border-bottom:1px solid #cccfd3;height:5rem;align-items:center;display:none}@media (min-width: 1280px){.wrapper[_ngcontent-%COMP%]{display:flex}}.header__main[_ngcontent-%COMP%]{width:100%;height:5rem;padding-top:.25rem;padding-bottom:.25rem;display:flex;align-items:center;gap:2rem}.header__main[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center;gap:1.5rem;width:100%;justify-content:end}.header__main[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__main[_ngcontent-%COMP%]{display:flex;align-items:center;width:100%;justify-content:end;height:3.5rem}.header__main[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .nav__main[_ngcontent-%COMP%]   .nav__group[_ngcontent-%COMP%]{display:flex;align-items:center;gap:2.75rem;height:100%}.header__main[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .search__bar[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;background-color:#edecf0;height:3.5rem;width:4rem;border-radius:9999px;opacity:1;z-index:10;transition:all .2s ease-in-out}.header__main[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .search__bar.hiddened[_ngcontent-%COMP%]{opacity:0;z-index:-10}.header__main[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .search__form[_ngcontent-%COMP%]{position:absolute;width:3.5rem;height:3.5rem;transition:all .3s ease-in-out;opacity:0}.header__main[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .search__form.opened[_ngcontent-%COMP%]{width:75%;height:3.5rem;opacity:1}.header__main[_ngcontent-%COMP%]   .login__button[_ngcontent-%COMP%]{width:147px;height:56px;display:flex;align-items:center;justify-content:center;font-size:14px;font-family:poppins-bold,Arial,sans-serif;color:#fff;background-color:#ed0226;border-radius:9999px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderMainComponent, [{
    type: Component,
    args: [{
      selector: 'shared-header-main',
      standalone: true,
      imports: [HeaderBaseComponent, HeaderNavFormComponent, HeaderNavItemComponent],
      template: "<shared-header-base [useBase]=\"false\" class=\"wrapper\">\r\n  <section class=\"header__main\">\r\n    <div class=\"container\">\r\n      <nav aria-label=\"Main Navigation\" class=\"nav__main\">\r\n        <ul class=\"nav__group\">\r\n          @for(nav of mainNavigation; track nav.title){\r\n          <li>\r\n            <shared-header-nav-item\r\n              [isActive]=\"nav.isActive\"\r\n              [title]=\"nav.title\"\r\n              [children]=\"nav.children\"\r\n              (onNavClicked)=\"onNavClicked($event)\"\r\n            ></shared-header-nav-item>\r\n          </li>\r\n          }\r\n        </ul>\r\n      </nav>\r\n      <shared-header-nav-form\r\n        class=\"search__form\"\r\n        [class.opened]=\"isFormDisplayed\"\r\n        (onClose)=\"onFormClose()\"\r\n        [isOpen]=\"isFormDisplayed\"\r\n      ></shared-header-nav-form>\r\n\r\n      <div class=\"search__bar\" [class.hiddened]=\"isFormDisplayed\">\r\n        <button (click)=\"formOpenHandler()\">\r\n          <img src=\"assets/images/search.png\" alt=\"\" />\r\n        </button>\r\n      </div>\r\n    </div>\r\n\r\n    <nav aria-label=\"Login Button\" class=\"login__button\">\r\n      <a [href]=\"loginUrl\" class=\"button\">Sign In</a>\r\n    </nav>\r\n  </section>\r\n</shared-header-base>\r\n",
      styles: [".wrapper{border-bottom:1px solid #cccfd3;height:5rem;align-items:center;display:none}@media (min-width: 1280px){.wrapper{display:flex}}.header__main{width:100%;height:5rem;padding-top:.25rem;padding-bottom:.25rem;display:flex;align-items:center;gap:2rem}.header__main .container{position:relative;display:flex;align-items:center;gap:1.5rem;width:100%;justify-content:end}.header__main .container .nav__main{display:flex;align-items:center;width:100%;justify-content:end;height:3.5rem}.header__main .container .nav__main .nav__group{display:flex;align-items:center;gap:2.75rem;height:100%}.header__main .container .search__bar{display:flex;align-items:center;justify-content:center;background-color:#edecf0;height:3.5rem;width:4rem;border-radius:9999px;opacity:1;z-index:10;transition:all .2s ease-in-out}.header__main .container .search__bar.hiddened{opacity:0;z-index:-10}.header__main .container .search__form{position:absolute;width:3.5rem;height:3.5rem;transition:all .3s ease-in-out;opacity:0}.header__main .container .search__form.opened{width:75%;height:3.5rem;opacity:1}.header__main .login__button{width:147px;height:56px;display:flex;align-items:center;justify-content:center;font-size:14px;font-family:poppins-bold,Arial,sans-serif;color:#fff;background-color:#ed0226;border-radius:9999px}\n"]
    }]
  }], null, null);
})();
class HeaderMainMobileComponent extends HeaderMainComponent {
  topRightNavigation = [];
  topLeftNavigatoin = [];
  isMenuOptionOpened = false;
  ngOnInit() {
    super.ngOnInit();
    this.headerService.topRightNavigation.subscribe(nav => {
      this.topRightNavigation = nav;
    });
    this.headerService.topLeftNavigation.subscribe(nav => {
      this.topLeftNavigatoin = nav;
    });
  }
  menuOptionHandler() {
    this.isMenuOptionOpened = !this.isMenuOptionOpened;
  }
  menuOptionCloseHandler() {
    this.isMenuOptionOpened = false;
  }
  formCloseHandler() {
    this.isFormDisplayed = false;
  }
  static ɵfac = /* @__PURE__ */(() => {
    let ɵHeaderMainMobileComponent_BaseFactory;
    return function HeaderMainMobileComponent_Factory(__ngFactoryType__) {
      return (ɵHeaderMainMobileComponent_BaseFactory || (ɵHeaderMainMobileComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HeaderMainMobileComponent)))(__ngFactoryType__ || HeaderMainMobileComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderMainMobileComponent,
    selectors: [["shared-header-main-mobile"]],
    standalone: true,
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
    decls: 31,
    vars: 5,
    consts: [[1, "wrapper"], [1, "header__main__mobile"], [3, "click"], ["src", "assets/images/search.png", "alt", "Search"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "viewBox", "0 0 24 24", "fill", "none", "stroke", "currentColor", "stroke-width", "2", "stroke-linecap", "round", "stroke-linejoin", "round", 1, "lucide", "lucide-menu"], ["x1", "4", "x2", "20", "y1", "12", "y2", "12"], ["x1", "4", "x2", "20", "y1", "6", "y2", "6"], ["x1", "4", "x2", "20", "y1", "18", "y2", "18"], [1, "overlay", 3, "click"], [1, "option"], [1, "option__wrapper"], ["src", "assets/images/close.png", "alt", "Close"], [1, "option__menu"], ["aria-label", "Top Right Navigation", 1, "shop__nav"], ["aria-label", "Top Left Navigation", 1, "personal__nav"], [3, "active"], [3, "onClose", "isOpen"], [3, "onNavClicked", "isActive", "title", "children"], [3, "href"]],
    template: function HeaderMainMobileComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "shared-header-base", 0)(1, "section", 1)(2, "button", 2);
        i0.ɵɵlistener("click", function HeaderMainMobileComponent_Template_button_click_2_listener() {
          return ctx.formOpenHandler();
        });
        i0.ɵɵelement(3, "img", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "button", 2);
        i0.ɵɵlistener("click", function HeaderMainMobileComponent_Template_button_click_4_listener() {
          return ctx.menuOptionHandler();
        });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(5, "svg", 4);
        i0.ɵɵelement(6, "line", 5)(7, "line", 6)(8, "line", 7);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵlistener("click", function HeaderMainMobileComponent_Template_div_click_9_listener() {
          return ctx.menuOptionCloseHandler();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 9)(11, "shared-header-base", 10)(12, "section", 1)(13, "button", 2);
        i0.ɵɵlistener("click", function HeaderMainMobileComponent_Template_button_click_13_listener() {
          return ctx.formOpenHandler();
        });
        i0.ɵɵelement(14, "img", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "button", 2);
        i0.ɵɵlistener("click", function HeaderMainMobileComponent_Template_button_click_15_listener() {
          return ctx.menuOptionCloseHandler();
        });
        i0.ɵɵelement(16, "img", 11);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(17, "section", 12)(18, "ul");
        i0.ɵɵrepeaterCreate(19, HeaderMainMobileComponent_For_20_Template, 2, 3, "li", null, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(21, "nav", 13)(22, "ul");
        i0.ɵɵrepeaterCreate(23, HeaderMainMobileComponent_For_24_Template, 3, 2, "li", null, _forTrack0);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(25, "nav", 14)(26, "ul");
        i0.ɵɵrepeaterCreate(27, HeaderMainMobileComponent_For_28_Template, 3, 4, "li", 15, _forTrack0);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(29, "shared-header-mobile-bottom");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "shared-header-mobile-nav-form", 16);
        i0.ɵɵlistener("onClose", function HeaderMainMobileComponent_Template_shared_header_mobile_nav_form_onClose_30_listener() {
          return ctx.formCloseHandler();
        });
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(9);
        i0.ɵɵclassProp("opened", ctx.isMenuOptionOpened);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("opened", ctx.isMenuOptionOpened);
        i0.ɵɵadvance(9);
        i0.ɵɵrepeater(ctx.mainNavigation);
        i0.ɵɵadvance(4);
        i0.ɵɵrepeater(ctx.topRightNavigation);
        i0.ɵɵadvance(4);
        i0.ɵɵrepeater(ctx.topLeftNavigatoin);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("isOpen", ctx.isFormDisplayed);
      }
    },
    dependencies: [HeaderBaseComponent, HeaderMobileNavItemComponent, HeaderMobileNavFormComponent, HeaderMobileBottomComponent],
    styles: [".wrapper[_ngcontent-%COMP%]{display:flex;width:100%;z-index:9999}@media (min-width: 1280px){.wrapper[_ngcontent-%COMP%]{display:none}}.wrapper[_ngcontent-%COMP%]   .header__main__mobile[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:end;height:3.5rem;width:100%;gap:1rem}.overlay[_ngcontent-%COMP%]{display:none}.overlay.opened[_ngcontent-%COMP%]{display:block;position:fixed;top:0;left:0;width:100%;height:100vh;background-color:#0000003f}.option[_ngcontent-%COMP%]{position:fixed;top:0;left:-110%;width:100vw;height:100vh;background-color:#fff;padding-bottom:9rem;transition:all .3s ease-in-out}.option.opened[_ngcontent-%COMP%]{left:0;overflow-y:scroll}.option[_ngcontent-%COMP%]   .option__wrapper[_ngcontent-%COMP%]{display:flex;width:100%}@media (min-width: 1280px){.option[_ngcontent-%COMP%]   .option__wrapper[_ngcontent-%COMP%]{display:none}}.option[_ngcontent-%COMP%]   .option__wrapper[_ngcontent-%COMP%]   .header__main__mobile[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:end;height:3.5rem;width:100%;gap:.75rem}.option[_ngcontent-%COMP%]   .option__menu[_ngcontent-%COMP%]{padding-top:1.25rem;padding-bottom:1.25rem;margin-bottom:3.5rem}.option[_ngcontent-%COMP%]   .shop__nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:1.25rem;border-top:1px solid #cccfd3;font-family:poppins-regular,Arial,sans-serif;font-size:13px;color:#001a41}.option[_ngcontent-%COMP%]   .shop__nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{border-bottom:1px solid #cccfd3}.option[_ngcontent-%COMP%]   .personal__nav[_ngcontent-%COMP%]{margin-top:1.5rem;margin-bottom:2.5rem}.option[_ngcontent-%COMP%]   .personal__nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:.125rem 1.25rem .25rem;font-family:poppins-regular,Arial,sans-serif;font-size:13px;color:#001a41;text-transform:uppercase}.option[_ngcontent-%COMP%]   .personal__nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]{position:relative}.option[_ngcontent-%COMP%]   .personal__nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]:after{position:absolute;content:\"\";bottom:0;left:0;height:100%;width:2px;background-color:#ed0226}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderMainMobileComponent, [{
    type: Component,
    args: [{
      selector: 'shared-header-main-mobile',
      standalone: true,
      imports: [HeaderBaseComponent, HeaderMobileNavItemComponent, HeaderMobileNavFormComponent, HeaderMobileBottomComponent],
      template: "<shared-header-base class=\"wrapper\">\r\n  <section class=\"header__main__mobile\">\r\n    <button (click)=\"formOpenHandler()\">\r\n      <img src=\"assets/images/search.png\" alt=\"Search\" />\r\n    </button>\r\n    <button (click)=\"menuOptionHandler()\">\r\n      <svg\r\n        xmlns=\"http://www.w3.org/2000/svg\"\r\n        width=\"24\"\r\n        height=\"24\"\r\n        viewBox=\"0 0 24 24\"\r\n        fill=\"none\"\r\n        stroke=\"currentColor\"\r\n        stroke-width=\"2\"\r\n        stroke-linecap=\"round\"\r\n        stroke-linejoin=\"round\"\r\n        class=\"lucide lucide-menu\"\r\n      >\r\n        <line x1=\"4\" x2=\"20\" y1=\"12\" y2=\"12\" />\r\n        <line x1=\"4\" x2=\"20\" y1=\"6\" y2=\"6\" />\r\n        <line x1=\"4\" x2=\"20\" y1=\"18\" y2=\"18\" />\r\n      </svg>\r\n    </button>\r\n  </section>\r\n</shared-header-base>\r\n\r\n<!-- Mobile Menu -->\r\n\r\n<div\r\n  class=\"overlay\"\r\n  [class.opened]=\"isMenuOptionOpened\"\r\n  (click)=\"menuOptionCloseHandler()\"\r\n></div>\r\n\r\n<div class=\"option\" [class.opened]=\"isMenuOptionOpened\">\r\n  <shared-header-base class=\"option__wrapper\">\r\n    <section class=\"header__main__mobile\">\r\n      <button (click)=\"formOpenHandler()\">\r\n        <img src=\"assets/images/search.png\" alt=\"Search\" />\r\n      </button>\r\n      <button (click)=\"menuOptionCloseHandler()\">\r\n        <img src=\"assets/images/close.png\" alt=\"Close\" />\r\n      </button>\r\n    </section>\r\n  </shared-header-base>\r\n  <section class=\"option__menu\">\r\n    <ul>\r\n      @for (item of mainNavigation; track $index) {\r\n      <li>\r\n        <shared-header-mobile-nav-item\r\n          [isActive]=\"item.isActive\"\r\n          [title]=\"item.title\"\r\n          [children]=\"item.children\"\r\n          (onNavClicked)=\"onNavClicked($event)\"\r\n        ></shared-header-mobile-nav-item>\r\n      </li>\r\n      }\r\n    </ul>\r\n  </section>\r\n\r\n  <nav aria-label=\"Top Right Navigation\" class=\"shop__nav\">\r\n    <ul>\r\n      @for(item of topRightNavigation; track item.title ){\r\n      <li>\r\n        <a href=\"{{ item.link }}\">\r\n          {{ item.title }}\r\n        </a>\r\n      </li>\r\n      }\r\n    </ul>\r\n  </nav>\r\n\r\n  <nav aria-label=\"Top Left Navigation\" class=\"personal__nav\">\r\n    <ul>\r\n      @for(item of topLeftNavigatoin; track item.title ){\r\n      <li [class.active]=\"item.isActive\">\r\n        <a href=\"{{ item.link }}\">\r\n          {{ item.title }}\r\n        </a>\r\n      </li>\r\n      }\r\n    </ul>\r\n  </nav>\r\n\r\n  <shared-header-mobile-bottom></shared-header-mobile-bottom>\r\n</div>\r\n\r\n<!-- Form Menu -->\r\n\r\n<shared-header-mobile-nav-form\r\n  [isOpen]=\"isFormDisplayed\"\r\n  (onClose)=\"formCloseHandler()\"\r\n></shared-header-mobile-nav-form>\r\n",
      styles: [".wrapper{display:flex;width:100%;z-index:9999}@media (min-width: 1280px){.wrapper{display:none}}.wrapper .header__main__mobile{display:flex;align-items:center;justify-content:end;height:3.5rem;width:100%;gap:1rem}.overlay{display:none}.overlay.opened{display:block;position:fixed;top:0;left:0;width:100%;height:100vh;background-color:#0000003f}.option{position:fixed;top:0;left:-110%;width:100vw;height:100vh;background-color:#fff;padding-bottom:9rem;transition:all .3s ease-in-out}.option.opened{left:0;overflow-y:scroll}.option .option__wrapper{display:flex;width:100%}@media (min-width: 1280px){.option .option__wrapper{display:none}}.option .option__wrapper .header__main__mobile{display:flex;align-items:center;justify-content:end;height:3.5rem;width:100%;gap:.75rem}.option .option__menu{padding-top:1.25rem;padding-bottom:1.25rem;margin-bottom:3.5rem}.option .shop__nav ul li{padding:1.25rem;border-top:1px solid #cccfd3;font-family:poppins-regular,Arial,sans-serif;font-size:13px;color:#001a41}.option .shop__nav ul li:last-child{border-bottom:1px solid #cccfd3}.option .personal__nav{margin-top:1.5rem;margin-bottom:2.5rem}.option .personal__nav ul li{padding:.125rem 1.25rem .25rem;font-family:poppins-regular,Arial,sans-serif;font-size:13px;color:#001a41;text-transform:uppercase}.option .personal__nav ul li.active{position:relative}.option .personal__nav ul li.active:after{position:absolute;content:\"\";bottom:0;left:0;height:100%;width:2px;background-color:#ed0226}\n"]
    }]
  }], null, null);
})();
class HeaderComponent {
  /**
   * Injects
   */
  headerService = inject(HeaderService);
  platformId = inject(PLATFORM_ID);
  /**
   * Bindings
   */
  onLanguageChange = new EventEmitter();
  headerRef;
  /**
   * Attributes
   */
  headerType = this.headerService.headerType.value;
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const localLang = localStorage.getItem('lang') ?? 'ID';
      if (localLang) {
        this.headerService.setLangType(localLang);
      }
    }
    this.headerService.langType.subscribe(langType => {
      this.onLanguageChange.emit(langType);
    });
    this.headerService.headerType.subscribe(headerType => {
      this.headerType = headerType;
    });
  }
  lastScroll = 0;
  ngAfterViewInit() {
    this.scrollSubscription();
  }
  scrollSubscription() {
    if (isPlatformBrowser(this.platformId)) {
      const headerElement = this.headerRef.nativeElement;
      window.addEventListener('scroll', () => {
        if (window.scrollY < this.lastScroll) {
          headerElement.classList.add('stick');
        } else {
          headerElement.classList.remove('stick');
        }
        if (window.scrollY === 0) {
          headerElement.classList.remove('stick');
        }
        this.lastScroll = window.scrollY;
      });
    }
  }
  static ɵfac = function HeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderComponent,
    selectors: [["shared-header"]],
    viewQuery: function HeaderComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c2, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerRef = _t.first);
      }
    },
    outputs: {
      onLanguageChange: "onLanguageChange"
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    decls: 4,
    vars: 2,
    consts: [["header", ""], [1, "header"], [3, "useBase"]],
    template: function HeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "header", 1, 0);
        i0.ɵɵtemplate(2, HeaderComponent_Conditional_2_Template, 3, 0)(3, HeaderComponent_Conditional_3_Template, 1, 1, "shared-header-base", 2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.headerType === "main" ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.headerType === "simple" ? 3 : -1);
      }
    },
    dependencies: [HeaderTopComponent, HeaderMainComponent, HeaderBaseComponent, HeaderMainMobileComponent],
    styles: [".header[_ngcontent-%COMP%]{background-color:#fff;position:sticky;top:-110%;transition:all .3s ease-in-out;box-shadow:none;z-index:9999}.header.stick[_ngcontent-%COMP%]{top:0;box-shadow:0 3px 10px #00000025}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderComponent, [{
    type: Component,
    args: [{
      selector: 'shared-header',
      standalone: true,
      imports: [HeaderTopComponent, HeaderMainComponent, HeaderBaseComponent, HeaderMainMobileComponent],
      template: "<header #header class=\"header\">\r\n  @if (headerType === 'main') {\r\n  <shared-header-top></shared-header-top>\r\n  <shared-header-main></shared-header-main>\r\n  <shared-header-main-mobile></shared-header-main-mobile>\r\n  } @if (headerType === 'simple') {\r\n  <shared-header-base [useBase]=\"true\"></shared-header-base>\r\n  }\r\n</header>\r\n",
      styles: [".header{background-color:#fff;position:sticky;top:-110%;transition:all .3s ease-in-out;box-shadow:none;z-index:9999}.header.stick{top:0;box-shadow:0 3px 10px #00000025}\n"]
    }]
  }], null, {
    onLanguageChange: [{
      type: Output
    }],
    headerRef: [{
      type: ViewChild,
      args: ['header']
    }]
  });
})();

/*
 * Public API Surface of component.header
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderComponent, HeaderService };
